module.exports = __webpack_public_path__ + "static/media/SmartShop_8-704w.c124d3e7.png";